export default __webpack_public_path__ + "static/media/5_pick_up_your_items.87845b63.png";